import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=bfbbe1a2&lang=pug&"
import script from "./Template.vue?vue&type=script&lang=js&"
export * from "./Template.vue?vue&type=script&lang=js&"
import style0 from "./Template.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfbbe1a2')) {
      api.createRecord('bfbbe1a2', component.options)
    } else {
      api.reload('bfbbe1a2', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=bfbbe1a2&lang=pug&", function () {
      api.rerender('bfbbe1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/Template.vue"
export default component.exports